import { array, option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { errorConstants, TError } from "../../../../../shared/src/codecs/errors";

export const logoErrorMessage = (validationErrors: TError): string | null =>
    pipe(
        validationErrors,
        array.findFirst(([code]) =>
            code === errorConstants.FILE_DOES_NOT_MATCH_CONTENT_TYPE
            || code === errorConstants.FILE_TOO_LARGE),
        option.fold(
            (): string | null => null,
            ([code]) =>
                code === errorConstants.FILE_TOO_LARGE
                    ? "That file is over 2MB. A logo this size is usually a photograph — try an exported PNG."
                    : "That file type can't be used. Upload a PNG, JPEG or WebP.",
        ),
    );
